/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the CreativeSetInfo HTTP resource (factory product). */
export class CreativeSetInfoResource {
}

/** Angular DI token for the CreativeSet HTTP resource (factory product). */
export class CreativeSetResource {
}

export function createCreativeSetInfoResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'creativesets/info',
    () => localUserProfile,
    'creativeSetInfo'
  );
}

export function createCreativeSetResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const CreativeSet: any = createAdnHttpResource(send, 'creativesets', () => localUserProfile, 'creativeSet');
  const uri = ApiConfig.obtain().getVersionedUri('creativesets');

  CreativeSet.copy = function(params: any): any {
    return {
      $promise: send({
        method: 'POST',
        url: uri + '/' + encodeURIComponent(params.id) + '/copy',
        params: _.pick(params, ['creativeSetId', 'name', 'copyCreatives', 'userState']),
        body: params
      })
    };
  };

  CreativeSet.copyCreativeSet = function(creativeSet: any, newId: any, copyCreatives: any): any {
    if (!creativeSet || !creativeSet.id) {
      return Promise.reject('Insufficient parameters for the creative set copy');
    }
    return CreativeSet.copy({
      id: creativeSet.id,
      creativeSetId: newId || '',
      name: creativeSet.name,
      copyCreatives: _.isBoolean(copyCreatives) ? copyCreatives : true,
      userState: creativeSet.userState || ''
    });
  };

  return CreativeSet;
}

export const creativeSetInfoResourceProvider = {
  provide: CreativeSetInfoResource,
  useFactory: createCreativeSetInfoResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const creativeSetResourceProvider = {
  provide: CreativeSetResource,
  useFactory: createCreativeSetResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

